// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { unlink16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-unlink': IconUnlink;
    }
}

/**
 * The icon component for the 'unlink' icon
 */
export class IconUnlink extends IconSvg {
    public constructor() {
        super(unlink16X16);
    }
}

registerIconSvg('icon-unlink', IconUnlink);
export const iconUnlinkTag = 'nimble-icon-unlink';
